import React from 'react';
import { connect } from 'react-redux';
// actions
import { getLensPackages } from '../../../actionCreators/editPower';
// components
import { Form } from 'react-final-form';
import ItemInfo from './ItemInfo';
import PackageGroup from './PackageGroup';

class ZeroPower extends React.PureComponent {
    constructor(props) {
        super(props);
        const p = props.item.options && props.item.options[0] || {};
        const pristine = { pkgid: p.oid, pkgname: p.name };
        this.state = { pristine };
        this.submit = this.submit.bind(this);
        this.getPackageName = this.getPackageName.bind(this);
    }
    componentDidMount() {
        const { getLensPackage, item } = this.props;
        const { productId: prodId, prescription = {}, frameType } = item || {};
        const powerType = prescription.powerType && prescription.powerType.toLowerCase();
        if (prodId) getLensPackage({ prodId, powerType, frameType });
    }
    componentDidUpdate(prevProps) {
        const { item } = this.props;
        if (prevProps.item !== item && item) {
            const p = item.options && item.options[0] || {};
            const pristine = { pkgid: p.oid, pkgname: p.name };
            (() => this.setState({ pristine }))();
        }
    }
    getPackageName(name) {
        this.selectedPackageName = name;
    }
    submit(values) {
        const { submitCallback, item } = this.props;
        if (this.state.pristine.pkgid !== values.pkgid) {
            const changedPackage = { name: this.selectedPackageName, value: values.pkgid };
            submitCallback([], item, changedPackage);
            return;
        }
        submitCallback([], item, null);
    }
    render() {
        const { item, lensPackages = [], powerSubmittedItemId, powerSubmitted, packageSubmittedItemId, packageSubmitted } = this.props;
        const { name, productId, dataLocale } = item || {};
        return (
            <React.Fragment>
                <ItemInfo name={name} productId={productId} dataLocale={dataLocale} />
                <Form
                    initialValues={this.state.pristine}
                    onSubmit={this.submit}
                >
                    {({ handleSubmit }) => (
                        <form onSubmit={handleSubmit} noValidate>
                            <PackageGroup dataLocale={dataLocale} name="pkgid" currentPackage={this.state.pristine.pkgname} packages={lensPackages} callback={this.getPackageName} />
                            {powerSubmittedItemId && item.id === powerSubmittedItemId && <div className={`margin-t10 margin-b10 fw700 fs14${powerSubmitted ? ' success-msg' : ' error-msg'}`}>{powerSubmitted ? 'Power Details Updated Successfully' : 'Power Details Update Failed'}</div>}
                            {packageSubmittedItemId && item.id === packageSubmittedItemId && <div className={`margin-t10 margin-b10 fw700 fs14${packageSubmitted ? ' success-msg' : ' error-msg'}`}>{packageSubmitted ? 'Package Updated Successfully' : 'Package Update Failed'}</div>}
                            <div className="submit-button margin-b20 margin-t15">
                                <button className="form-SLA_field-row_submit bora-2 fs16 fw700" type="submit" style={{ width: '200px' }}>Submit</button>
                            </div>
                        </form>
                    )}
                </Form>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { productId: pid, prescription = {} } = ownProps.item || {};
    const powerType = prescription.powerType && prescription.powerType.toLowerCase();
    const lensPackages = state.editPower.pidToPkgs ? state.editPower.pidToPkgs[pid + powerType] : undefined;
    return {
        lensPackages,
        powerSubmittedItemId: state.success.powerSubmittedItemId,
        powerSubmitted: state.success.powerSubmitted,
        packageSubmittedItemId: state.success.packageSubmittedItemId,
        packageSubmitted: state.success.packageSubmitted,
        dataLocale: state.locale
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getLensPackage: data => dispatch(getLensPackages(data))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ZeroPower);
